// src/utils/toastUtils.js
import { toast } from 'react-toastify';

export const showSuccessToast = (message) => {
  toast.success(message, {
    className: 'custom-toast success',
    bodyClassName: "grow font-weight-bold",
    progressClassName: "fancy-progress-bar success"
  });
};

export const showErrorToast = (message) => {
  toast.error(message, {
    className: 'custom-toast error',
    bodyClassName: "grow font-weight-bold",
    progressClassName: "fancy-progress-bar error"
  });
};

export const showInfoToast = (message) => {
  toast.info(message, {
    className: 'custom-toast info',
    bodyClassName: "grow font-weight-bold",
    progressClassName: "fancy-progress-bar info"
  });
};

export const showWarningToast = (message) => {
  toast.warn(message, {
    className: 'custom-toast warning',
    bodyClassName: "grow font-weight-bold",
    progressClassName: "fancy-progress-bar warning"
  });
};